<template>
  <b-modal @hide="modalClose" ref="orderingContactModal" :title="$t('登録')" size="lg">
    <b-container fluid>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('国') }}
        </label>
        <div class="col-sm-8">
          <select
            v-model="form.countryCode"
            class="form-control"
            id="exampleFormControlSelect1"
          >
            <template>
              <option
                v-for="(item, index) in country"
                :key="index"
                :value="item.code"
              >{{ $t(item.name) }}</option>
            </template>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('送り先と注文先') }}
          <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
        </label>
        <div class="col-sm-8">
          <input v-model="form.name" type="text" class="form-control" placeholder />
        </div>
      </div>
      <div class="form-group row" v-if="form.countryCode === 'JP'">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('カナ') }}
        </label>
        <div class="col-sm-8">
          <input v-model="form.kana" type="text" class="form-control" />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('送り先と注文先コード') }}
        </label>
        <div class="col-sm-8">
          <input v-model="form.code" type="text" class="form-control" />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('郵便番号') }}
        </label>
        <div class="col-sm-8">
          <input v-model="form.zipcode" type="text" class="form-control" />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          <template v-if="form.countryCode === 'JP'">
            {{ $t('都道府県') }}
          </template>
          <template v-else>{{ $t('州') }}</template>
        </label>
        <div class="col-sm-8">
          <select
            v-model="form.prefCode"
            class="form-control"
            id="exampleFormControlSelect1"
          >
            <option value></option>
            <template v-if="form.countryCode">
              <option
                v-for="(item, index) in pref[form.countryCode]"
                :key="index"
                :value="item.code"
              >{{ $t(item.name) }}</option>
            </template>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('住所1') }}
        </label>
        <div class="col-sm-8">
          <input v-model="form.address1" type="text" class="form-control" />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('住所2') }}
        </label>
        <div class="col-sm-8">
          <input v-model="form.address2" type="text" class="form-control" />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('住所3') }}
        </label>
        <div class="col-sm-8">
          <input v-model="form.address3" type="text" class="form-control" />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('TEL') }}
        </label>
        <div class="col-sm-8">
          <input v-model="form.phoneNo" type="tel" class="form-control" />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('FAX') }}
        </label>
        <div class="col-sm-8">
          <input v-model="form.faxNo" type="tel" class="form-control" />
        </div>
      </div>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="error">{{ error }}</p>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          :disabled="registering"
          @click="register()"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="registering"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t('登録') }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          :disabled="registering"
          @click="modalClose()"
        >{{ $t('キャンセル') }}</button>
    </div>
    </template>
  </b-modal>
</template>

<script>
import country from '../../assets/json/country.json'
import { mapGetters } from 'vuex'
import pref from '../../assets/json/pref.json'
const form = {
  partnerId: null,
  name: '',
  kana: '',
  code: '',
  zipcode: '',
  prefCode: '',
  address1: '',
  address2: '',
  address3: '',
  phoneNo: '',
  faxNo: '',
  countryCode: '',
}
export default {
  data() {
    return {
      country: country,
      form: {},
      error: '',
      registering: false,
      pref: pref,
    }
  },
  methods: {
    // モーダルを開いたときの処理
    async modalOpen(id = null, partnerId, countryCode) {
      this.$refs.orderingContactModal.show()
      if (!id) {
        this.form = this.mixin_deepcopy(form)
        this.form.partnerId = partnerId
        this.form.countryCode = countryCode
      } else {
        try {
          const res = await this.$axios.get(
            `${this.$appConfig.CommonApiUrl}/ordering/contacts`,
            {
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
              params: { id: id, partnerId: partnerId },
            }
          )
          this.form = res.data[0]
        } catch (err) {
          this.$toasted.show(err)
          this.$emit('modalClose')
          this.$refs.orderingContactModal.hide()
        }
        return
      }
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.$refs.orderingContactModal.hide()
      this.$emit('modalClose')
    },
    // 登録処理
    async register() {
      this.error = ''
      try {
        if (!this.form.name)
          return (this.error = this.$t('送り先と注文先') + this.$t('必須メッセージ'))
        this.registering = true
        let params = {}
        for (let key of Object.keys(this.form)) {
          if (this.form[key]) params[key] = this.form[key]
        }
        this.registering = true
        const method = this.form.id ? 'put' : 'post'
        await this.$axios({
          method: method,
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/ordering/contact`,
          data: params,
        })
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.$refs.orderingContactModal.hide()
        this.$emit('registed')
      } catch (err) {
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }
      this.registering = false
    },
    // 削除処理
    async deleteAlert() {
      const confirm = await this.$swal({
        text: this.$t('削除して本当によろしいでしょうか？'),
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: this.$('OK'),
            value: true,
            visible: true,
            className: '',
            closeModal: false,
          },
        },
        dangerMode: true,
      })
      if (!confirm) return
      try {
        await this.$axios.delete(
          `${this.$appConfig.CommonApiUrl}/ordering/contact`,
          { id: this.form.id, isDelete: true },
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        this.$swal.close()
        this.$toasted.success(this.$t('データ削除完了メッセージ'))
        this.$emit('modalClose')
        $('#orderingContactModal').modal('hide')
      } catch (err) {
        this.$swal.close()
        this.$toasted.show(this.$t('データ削除エラーメッセージ'))
      }
    },
  },
  watch: {
    'form.zipcode': function(zip) {
      let _this = this.form
      if (_this.countryCode != 'JP') return
      // NOTE: html上で直接scriptを呼び出している
      // eslint-disable-next-line no-undef
      new YubinBango.Core(zip, function(addr) {
        _this.prefCode = addr.region_id ? 'JP-' + addr.region_id : '' // 都道府県ID
        _this.address1 = addr.locality // 市区町村
        _this.address2 = addr.street // 町域
      })
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>

<style lang="scss" scoped>
#orderingContactModal {
  .modal-dialog {
    max-width: 80rem;
  }
}
</style>
